/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NonPresentPreferenceParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-present')],
]);
export class NonPresentPreference extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NonPresentPreferenceParser.decode(input).map(res => new NonPresentPreference(res));
    }
    static unsafeDecode(input) {
        return NonPresentPreference.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NonPresentPreferenceParser.encode(data);
    }
    static schema() {
        return NonPresentPreferenceParser.schema();
    }
}
